import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import { useModalDismiss } from "@/helper/customHooks/useModalDismiss";
import styles from "@/components/userAdministration/userTable/dialogs/userMailLogDialog.module.css";
import type {
  MailRecipient,
  SentMail,
} from "@/components/userAdministration/userTable/dialogs/useUserMailLogDialog";

interface Props {
  open: boolean;
  onClose: () => void;
  recipient: MailRecipient;
  sentMails: SentMail[];
}

const pad = (value: number) => String(value).padStart(2, "0");

const formatSentOn = (sentOn: string) => {
  const time = new Date(sentOn);
  return (
    pad(time.getDate()) +
    "." +
    pad(time.getMonth() + 1) +
    "." +
    String(time.getFullYear()) +
    " - " +
    pad(time.getHours()) +
    ":" +
    pad(time.getMinutes()) +
    ":" +
    pad(time.getSeconds())
  );
};

export default function UserMailLogDialog(props: Props) {
  const { t } = useTranslation();
  const cancelClose = useModalDismiss(props.open, props.onClose);
  const newestFirst = [...props.sentMails].sort((a, b) =>
    b.sent_on.localeCompare(a.sent_on)
  );

  return (
    <Dialog open={props.open} scroll="paper" {...cancelClose}>
      <DialogTitle textAlign={"center"}>
        {t("sent_mails_to_user", {
          userInfo:
            props.recipient.firstName +
            " " +
            props.recipient.lastName +
            ", " +
            props.recipient.email,
        })}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          display={"flex"}
          flexDirection={"column"}
          component={"div"}
        >
          <table>
            <thead>
              <tr>
                <td className={styles.tableHeaderCell}>{t("time_point")}</td>
                <td className={styles.tableCell}>{t("mail_template")}</td>
                <td className={styles.tableCell}>{t("status")}</td>
              </tr>
            </thead>
            <tbody>
              {newestFirst.length > 0 ? (
                newestFirst.map((mail) => (
                  <tr key={mail.sent_on}>
                    <td className={styles.tableCell}>
                      {formatSentOn(mail.sent_on)}
                    </td>
                    <td className={styles.tableCell}>{mail.template_name}</td>
                    <td
                      className={styles.statusCell}
                      style={{ color: mail.status_color }}
                    >
                      {mail.status}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>{t("no_mails_sent_to_user")}</td>
                </tr>
              )}
            </tbody>
          </table>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <GenericButton onClick={props.onClose}>{t("ok_capital")}</GenericButton>
      </DialogActions>
    </Dialog>
  );
}
